/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityProcessResponse } from './MonitEntityProcessResponse';
import {
    MonitEntityProcessResponseFromJSON,
    MonitEntityProcessResponseFromJSONTyped,
    MonitEntityProcessResponseToJSON,
} from './MonitEntityProcessResponse';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityProcessesResponse
 */
export interface MonitPaginatedEntityProcessesResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityProcessesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityProcessesResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityProcessesResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityProcessResponse>}
     * @memberof MonitPaginatedEntityProcessesResponse
     */
    results: Array<MonitEntityProcessResponse>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityProcessesResponse interface.
 */
export function instanceOfMonitPaginatedEntityProcessesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function MonitPaginatedEntityProcessesResponseFromJSON(json: any): MonitPaginatedEntityProcessesResponse {
    return MonitPaginatedEntityProcessesResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityProcessesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityProcessesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(MonitEntityProcessResponseFromJSON)),
    };
}

export function MonitPaginatedEntityProcessesResponseToJSON(value?: MonitPaginatedEntityProcessesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(MonitEntityProcessResponseToJSON)),
    };
}

